module.exports = __webpack_public_path__ + "static/img/potenciometro_5k-1.aaad754.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/potenciometro_5k-1.svg
// module id = /ys4
// module chunks = 0